import { init as initApm } from '@elastic/apm-rum';

const apm = initApm({
  serviceName: window.config.apmServiceName || 'myedu-widget-ui',
  serverUrl: window.config.apmUrl,
  environment: window.config.elasticEnvironment,
  serviceVersion: process.env.REACT_APP_VERSION || window.config.apmVersion || 'test',
  transactionSampleRate: 1.0
});

export default apm;